// Module
var code = "<template>\n    <div class=\"organizational-unit-path\">\n        <span class=\"text-service\" repeat.for=\"parent of parents\">${parent}</span>\n    </div>\n    <div class=\"selected-cost-center\">\n        <span>${selectedTreeNode.title}</span>\n    </div>\n</template>\n";
// Exports
export default code;